import { render, staticRenderFns } from "./ActiveInfo.vue?vue&type=template&id=545a0714&scoped=true&"
import script from "./ActiveInfo.vue?vue&type=script&lang=js&"
export * from "./ActiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActiveInfo.vue?vue&type=style&index=0&id=545a0714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a0714",
  null
  
)

export default component.exports